import type { TourStep } from '../interfaces'

export const GLOBAL_STEPS: TourStep[] = [
  {
    target: 'sidebar-logo',
    titleKey: 'tour.steps.logo.title',
    descriptionKey: 'tour.steps.logo.description',
    position: 'right',
  },
  {
    target: 'sidebar-nav',
    titleKey: 'tour.steps.sidebarNav.title',
    descriptionKey: 'tour.steps.sidebarNav.description',
    position: 'right',
  },
  {
    target: 'topbar-title',
    titleKey: 'tour.steps.pageTitle.title',
    descriptionKey: 'tour.steps.pageTitle.description',
    position: 'bottom',
  },
  {
    target: 'topbar-search',
    titleKey: 'tour.steps.search.title',
    descriptionKey: 'tour.steps.search.description',
    position: 'bottom',
  },
  {
    target: 'topbar-store',
    titleKey: 'tour.steps.store.title',
    descriptionKey: 'tour.steps.store.description',
    position: 'bottom',
  },
  {
    target: 'topbar-howto',
    titleKey: 'tour.steps.howTo.title',
    descriptionKey: 'tour.steps.howTo.description',
    position: 'bottom',
  },
  {
    target: 'topbar-user',
    titleKey: 'tour.steps.userMenu.title',
    descriptionKey: 'tour.steps.userMenu.description',
    position: 'bottom',
  },
  {
    target: 'main-content',
    titleKey: 'tour.steps.mainContent.title',
    descriptionKey: 'tour.steps.mainContent.description',
    position: 'top',
  },
]

export const BOOKING_STEPS: TourStep[] = [
  {
    target: 'booking-mode-toggle',
    titleKey: 'tour.steps.bookingModeToggle.title',
    descriptionKey: 'tour.steps.bookingModeToggle.description',
    position: 'bottom',
  },
  {
    target: 'booking-view-tabs',
    titleKey: 'tour.steps.bookingViewTabs.title',
    descriptionKey: 'tour.steps.bookingViewTabs.description',
    position: 'bottom',
  },
  {
    target: 'booking-nav-controls',
    titleKey: 'tour.steps.bookingNavControls.title',
    descriptionKey: 'tour.steps.bookingNavControls.description',
    position: 'bottom',
  },
  {
    target: 'booking-new-btn',
    titleKey: 'tour.steps.bookingNewBtn.title',
    descriptionKey: 'tour.steps.bookingNewBtn.description',
    position: 'bottom',
  },
]

export const NEW_BOOKING_STEPS: TourStep[] = [
  {
    target: 'newbooking-steps',
    titleKey: 'tour.steps.newBookingSteps.title',
    descriptionKey: 'tour.steps.newBookingSteps.description',
    position: 'bottom',
  },
  {
    target: 'newbooking-customer-tab',
    titleKey: 'tour.steps.newBookingCustomerTab.title',
    descriptionKey: 'tour.steps.newBookingCustomerTab.description',
    position: 'bottom',
  },
  {
    target: 'newbooking-services',
    titleKey: 'tour.steps.newBookingServices.title',
    descriptionKey: 'tour.steps.newBookingServices.description',
    position: 'top',
  },
  {
    target: 'newbooking-schedule',
    titleKey: 'tour.steps.newBookingSchedule.title',
    descriptionKey: 'tour.steps.newBookingSchedule.description',
    position: 'top',
  },
  {
    target: 'newbooking-confirm',
    titleKey: 'tour.steps.newBookingConfirm.title',
    descriptionKey: 'tour.steps.newBookingConfirm.description',
    position: 'top',
  },
  {
    target: 'newbooking-nav',
    titleKey: 'tour.steps.newBookingNav.title',
    descriptionKey: 'tour.steps.newBookingNav.description',
    position: 'top',
  },
]
